export type ShiftStatus =
    "Draft" | "Submitted" | "Scheduled" | "Cancelled" | "Completed"

export interface Shift {
    id: string
    cleaner_id: string
    status: ShiftStatus
    cleanerStart: number
    cleanerEnd: number
    managerStart?: number
    managerEnd?: number
}

export const getShiftCurrentTime = (shift: Shift) => {
    if (shift.status === "Draft" || shift.status === "Submitted") {
        return { start: shift.cleanerStart, end: shift.cleanerEnd }
    } else if (shift.status === "Scheduled") {
        if (shift.managerStart && shift.managerEnd) {
            return { start: shift.managerStart, end: shift.managerEnd }
        } else {
            // ここには来ないはず、型のために書いている
            return { start: shift.cleanerStart, end: shift.cleanerEnd }
        }
    } else if (shift.status === "Cancelled") {
        if (shift.managerStart && shift.managerEnd) {
            return { start: shift.managerStart, end: shift.managerEnd }
        } else {
            return { start: shift.cleanerStart, end: shift.cleanerEnd }
        }
    } else {
        return { start: shift.cleanerStart, end: shift.cleanerEnd }
    }
}

export const isShiftTimeChangedByManager = (shift: Shift) => {
    return (
        shift.cleanerStart !== shift.managerStart ||
        shift.cleanerEnd !== shift.managerEnd
    )
}
